import React, { useState, useEffect, useRef } from "react";
import ApiService from "../../services/Api.service";
import { Play } from "lucide-react";

export default function AudioPlayer({ callId, duration, activeCallId, setActiveCallId }) {
    const [audioUrl, setAudioUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const audioRef = useRef(null);

    const isActive = activeCallId === callId;

    // Whenever activeCallId changes, if this is NOT the active call, reset the audio player
    useEffect(() => {
        if (!isActive) {
            setAudioUrl(null); // reset URL to hide player and show play button again
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }
        }
    }, [isActive]);

    const handlePlayClick = async () => {
        if (loading || audioUrl) return;

        setLoading(true);
        try {
            const res = await ApiService.getRecordingSignedUrl(callId);
            if (res?.data?.data) {
                setAudioUrl(res.data.data);
                setActiveCallId(callId); // set this call as active
            }
        } catch (error) {
            console.error("Failed to fetch signed URL:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                justifyContent: "center",
                flexDirection: "row",
            }}
        >
            

            {/* Show audio player if url exists and this is active, else play button */}
            {audioUrl && isActive ? (
                <audio
                    ref={audioRef}
                    src={audioUrl}
                    controls
                    autoPlay
                />
            ) : (
                <button
                    onClick={handlePlayClick}
                    disabled={loading}
                    style={{
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                    }}
                    aria-label="Play recording"
                >
                    {/* Always show duration */}
            <Play size={20} />
                </button>
            )}
        </div>
    );
}
